import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Drawer } from '@mui/material';
import CloseButton from 'components/@home/drawers/CloseButton';
import PasskeyManagementForm from './PasskeyManagementForm';
import connector from './connector';

class PasskeyManagementDrawer extends Component {
  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { open, company, employee, isMe } = this.props;

    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={this.handleClose}
        slotProps={{
          paper: {
            sx: {
              width: 600,
              maxWidth: '90%',
              display: 'flex',
              flexDirection: 'row',
              overflow: 'visible',
              alignItems: 'flex-start',
              paddingTop: '20px',
              paddingLeft: '20px',
            },
          },
        }}
      >
        <CloseButton onClick={this.handleClose} />
        <Box
          sx={{
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            marginTop: '-20px',
          }}
        >
          <PasskeyManagementForm company={company} employee={employee} isMe={isMe} />
        </Box>
      </Drawer>
    );
  }
}

PasskeyManagementDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  company: PropTypes.shape({
    _id: PropTypes.string,
  }),
  employee: PropTypes.shape({
    _id: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    surName: PropTypes.string,
  }),
  isMe: PropTypes.bool,
};

PasskeyManagementDrawer.defaultProps = {
  open: false,
  onClose: null,
  company: null,
  employee: null,
  isMe: false,
};

export default connector(PasskeyManagementDrawer);
